import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import { timer } from 'rxjs';
import { QuestionBaseComponent } from '@core/form-generator-engine/abstractions';
import { QuestionControl } from '@core/form-generator-engine/composite-pattern';

@Component({
  standalone: false,
  selector: 'gstar-textfield-question',
  templateUrl: './textfield-question.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./textfield-question.component.scss'],
})
export class TextfieldQuestionComponent
  implements AfterViewInit, QuestionBaseComponent
{
  @Input() question!: QuestionControl;

  @ViewChild('field', { static: false })
  field!: { cdr: ChangeDetectorRef };

  ngAfterViewInit(): void {
    timer(0).subscribe(() => {
      this.field.cdr.detectChanges();
    });
  }
}
